export const PLAN_TASK_TITLE_NAME_MAX_WIDTH = 212;
